import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';

import { sync } from 'vuex-router-sync';

import ShardsVue from 'shards-vue';

import * as VueGoogleMaps from 'vue2-google-maps';
import GoogleApiService from '_services/common/googleApiService';

// Styles
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/scss/shards-dashboards.scss';
import '@/assets/scss/date-range.scss';

// Core
import App from './App.vue';
import store from './store';
import router from './router';

ShardsVue.install(Vue);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

Vue.use(BootstrapVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: GoogleApiService.getApiKey(),
    libraries: 'places',
  },
});

sync(store, router);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
